import React from 'react';
import { connect } from 'react-redux';
import { Text, i18n, tokens, Modal } from '@simplybenefits/sb-ui-library';

/**
 *
 * @param {*} param0
 */
const ClaimErrorModal = ({ fixableClaimErrors, onClose, onEdit, onSave, loader }) => (
    <Modal
        open={true}
        onClose={ onClose }
        loader={ loader }
        title={ i18n.t(tokens.labels.claims.confirmContinue) }
        secondaryButton={{
            label: i18n.t(tokens.buttons.continueAnyway),
            onClick: onSave
        }}
        primaryButton={{
            label: i18n.t(tokens.buttons.editSubmission),
            onClick: onEdit
        }}
    >
        {
            fixableClaimErrors.map((error, i) => (
                <Text
                    display="block"
                    medium
                    margin="10px 0px 10px 0px"
                    key={i}
                >
                    { error }
                </Text>
            ))
        }

        <Text
            display="block"
            medium
            margin="20px 0px 0px 0px"
            light
        >
            { i18n.t(tokens.labels.claims.quickReimbursementNote) }
        </Text>
    </Modal>
);

export default connect()(ClaimErrorModal);